@if (isOpen) {
    <div>
        <form
            [formGroup]="form"
            (submit)="submit()"
        >
            <div class="grid-container">
                <div class="g-12 m-12:b md:m-16:b lg:m-24:b">
                    <p>Bitte gib an, wann dein Versicherungsvertrag in Kraft treten soll.</p>
                </div>
                <div class="date-picker g-12 form-control">
                    <label id="contract-start-label">Vertragsbeginn:</label>
                    <app-contract-start-picker
                        formControlName="contractStart"
                        [monthsInAdvance]="product().orderConfig.monthsInAdvance"
                        [mode]="product().orderConfig.contractStartMode"
                        labelledById="contract-start-label"
                    ></app-contract-start-picker>
                    <app-error-messages
                        formControlName="contractStart"
                        [messages]="contractStartError"
                    ></app-error-messages>
                </div>
            </div>
            <!-- #region price display -->
            <app-inline-price-display
                [price]="price()"
                [settlementPeriod]="settlementPeriod()"
                [taxInfo]="taxInfo()"
            />
            <!-- #endregion -->
            <app-navigation-buttons
                [nextDisabled]="form.invalid"
                [showBack]="isFirstStep"
                (prev)="btnPrev()"
                (next)="submit()"
                nextTooltip="Bitte wähle das Datum, an dem dein Versicherungsvertrag in Kraft treten soll."
            ></app-navigation-buttons>
        </form>
    </div>
}
